import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider, IconButton,
  List,
  Typography,
  useMediaQuery,
  useTheme,

} from '@mui/material'
import { FC, useEffect } from 'react'

import { HIWListItem } from './HIWListItem'
import { AddressPinIcon } from '../../icons/AddressPinIcon'
import { CircleCheckIcon, GearIcon, RulerIcon } from '../../icons'
import { CloseIcon } from '../../icons/CloseIcon'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../../store'
import { AppActions, AppSelector } from '../../../store/app'
import { Cookies } from 'react-cookie'



export const HowItWorksModal: FC = () => {
  const theme= useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch<AppDispatch>()
  const isOpen = useSelector(AppSelector.getHowItWorksModalState)

  const items = [
    {
      title: 'Enter Address',
      description: 'Type your address into the search bar to locate nearby water utilities',
      avatarContent: 1,
      icon: <AddressPinIcon color='primary'/>,
    },
    {
      title: 'Adjust radius',
      description: 'If your utility isn\'t listed, expand the search radius using the dropdown for broader results.',
      avatarContent: 2,
      icon: <GearIcon color="primary"/>,
    },
    {
      title: 'View metrics',
      description: 'Click on a utility from the list or map to see detailed metrics, including violations over time.',
      avatarContent: 3,
      icon:<RulerIcon color='primary'/>,
    },
    {
      title: 'Request test strip',
      description: 'For personalized home testing, request a free test strip, we\'ll mail it to you. Dip, scan, and get your results!',
      avatarContent: 4,
      icon: <CircleCheckIcon color='primary' stroke='#00598E' strokeWidth={6} />,
    },
  ]

  const handleClose = () => {
    dispatch(AppActions.setHowItWorksModalOpen(false))
  }

  useEffect(() => {
    const cookies = new Cookies()
    const cookie = cookies.get('hiw_cook', {})
    if(!cookie) {
      dispatch(AppActions.setHowItWorksModalOpen(true))
      cookies.set('hiw_cook', true, {expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000)} )
    }
  }, [dispatch])

  return (
    <Dialog
      open={isOpen}
      fullScreen={isMobile}
      slotProps={{
        paper:{
          sx:{borderRadius: isMobile ? 0 : theme.shape.borderRadius as number * 1.5}
        }
      }}>
      <DialogTitle>Welcome to SIPPlytics!</DialogTitle>
      <IconButton

        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          See your water. Know your risks. Trust every sip.{' '}
        </Typography>
        <Typography>
          SIPPlytics gives your community real-time, transparent insights into water safety, so you
          can see the risks, protections, and truths behind your tap.
        </Typography>
        <List>
          {items.map((item) => (
            <HIWListItem {...item} key={item.title} />
          ))}
        </List>
      </DialogContent>
      <DialogActions sx={{px:3}}>
        <Button
          variant="contained"
          size='large' fullWidth onClick={handleClose}>Get Started</Button>
      </DialogActions>
    </Dialog>
  )
}
